const breadCrumb = "Diário Digital - Instrumentos Pedagógicos";

const routes = [
  {
    path: "/instrumentos-pedagogicos",
    name: "instrumentos-pedagogicos",
    meta: {
      allowedPermissions: ["instrumento_pedagogico_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/InstrumentosPedagogicos/InstrumentosPedagogicosHome.vue"
      ),
  },
  {
    path: "/instrumentos-pedagogicos/novo",
    name: "instrumentos-pedagogicos-novo",
    meta: {
      allowedPermissions: ["instrumento_pedagogico_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/InstrumentosPedagogicos/InstrumentosPedagogicosCad.vue"
      ),
  },
  {
    path: "/instrumentos-pedagogicos/editar/:id",
    name: "instrumentos-pedagogicos-editar",
    meta: {
      allowedPermissions: ["instrumento_pedagogico_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/InstrumentosPedagogicos/InstrumentosPedagogicosEdit.vue"
      ),
  },
];

export default routes;
